<template>
  <v-card class="cancellable-trades">
    <v-card-title class="toolbar white--text">
      <h3>Cancellable trades ({{ filteredItems.length }})</h3>
      <div
        v-if="selected.length > 0"
        class="ml-3"
      >
        <v-tooltip
          top
          dark
        >
          <template v-slot:activator="{ on }">
            <v-btn
              dark
              flat
              icon
              @click="approveModalOpen = true"
              v-on="on"
            >
              <v-icon>cancel_schedule_send</v-icon>
            </v-btn>
          </template>
          <span>Cancel Trade(s)</span>
        </v-tooltip>
      </div>

      <v-spacer />
      <v-text-field
        v-model="search"
        primary
        dark
        solo-inverted
        flat
        append-icon="search"
        label="Search"
        single-line
        hide-details
      />
    </v-card-title>

    <v-data-table
      v-model="selected"
      :headers="headers"
      :items="filteredItems"
      :pagination.sync="pagination"
      :rows-per-page-items="rowsPerPageItems"
      :search="search"
      :loading="loading"
      select-all
      item-key="id"
      class="elevation-1"
      @update:pagination="updatePagination"
    >
      <template v-slot:items="props">
        <tr
          :active="props.selected"
          @click="toogleSelected(props)"
        >
          <td>
            <v-checkbox
              :input-value="props.selected"
              color="primary"
              hide-details
            />
          </td>
          <td>
            {{ props.item.id }}
          </td>
          <td>
            {{ props.item.offer_type }}
          </td>
          <td>
            {{ props.item.offer.id }}
          </td>
          <td>
            {{ props.item.offer.asset.title }}
          </td>
          <td>
            {{ props.item.offer.security_wallet }}
          </td>
          <td>
            {{ formatField(props.item.state) }}
          </td>
          <td>
            {{ centsToEuros(props.item.total) }}
          </td>
          <td class="text-xs-center">
            <v-tooltip
              top
              dark
            >
              <template v-slot:activator="{ on }">
                <v-chip
                  color="grey"
                  outline
                  small
                  v-on="on"
                >
                  <span>
                    {{ formatDateSmall(props.item.created_at) }}
                  </span>
                </v-chip>
              </template>
              {{ formatDate(props.item.created_at) }}
            </v-tooltip>
          </td>
          <td class="text-xs-center">
            <v-tooltip
              top
              dark
            >
              <template v-slot:activator="{ on }">
                <v-chip
                  color="grey"
                  outline
                  small
                  v-on="on"
                >
                  <span>
                    {{ formatDateSmall(props.item.updated_at) }}
                  </span>
                </v-chip>
              </template>
              {{ formatDate(props.item.updated_at) }}
            </v-tooltip>
          </td>
        </tr>
      </template>
    </v-data-table>

    <v-dialog
      v-model="approveModalOpen"
      width="600"
      persistent
    >
      <v-card>
        <v-card-title
          class="headline grey lighten-2"
          primary-title
        >
          Cancel Selected Trades
        </v-card-title>
        <v-card-text>
          Please confirm that you really want to <strong>delete</strong> the next Trade(s) ID(s):
          <strong>{{ selected.map(select=> select.id).join(', ') }}</strong>
        </v-card-text>

        <v-form
          ref="tradeForm"
          @submit.prevent="cancelTrades"
        >
          <v-divider />

          <v-card-actions>
            <v-spacer />
            <v-btn
              flat
              @click="approveModalOpen = false"
            >
              Close
            </v-btn>
            <e-button
              flat
              type="submit"
              color="blue"
              text="Cancel trades"
              :loading="loading"
              @click="approveModalOpen = true"
            />
          </v-card-actions>
        </v-form>
      </v-card>
    </v-dialog>
    <v-dialog
      v-model="cancelModalOpen"
      width="600"
      persistent
    >
      <v-card>
        <v-card-title
          class="headline grey lighten-2"
          primary-title
        >
          Cancel Selected Trades
        </v-card-title>
        <v-card-text>
          Please confirm that the next ID(s) Trade(s) have been transferred:
          <strong>{{ selected.map(select=> select.id).join(', ') }}</strong>
        </v-card-text>

        <v-form
          ref="tradeForm"
          @submit.prevent="cancelTrades"
        >
          <v-divider />

          <v-card-actions>
            <v-spacer />
            <v-btn
              flat
              @click="cancelModalOpen = false"
            >
              Close
            </v-btn>
            <e-button
              flat
              type="submit"
              color="blue"
              text="Cancel Trades"
              :loading="loading"
            />
          </v-card-actions>
        </v-form>
      </v-card>
    </v-dialog>
  </v-card>
</template>

<script>
import _ from 'lodash';
import { mapActions } from 'vuex';
import { Button } from '@/components/shared';
import { setQuery } from '@/helpers';


export default {
  name: 'CancellableTrades',
  components: {
    'e-button': Button,
  },
  props: {
    trades: {
      type: Array,
      default: () => [],
    },
    loading: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      approveModalOpen: false,
      cancelModalOpen: false,
      isLoadTableData: false,
      search: '',
      selected: [],
      pagination: {
        page: 1,
        rowsPerPage: 25,
        totalItems: 0,
        sortBy: 'createdAt',
        descending: true,
      },
      rowsPerPageItems: [
        {
          text: '10',
          value: 10,
        },
        {
          text: '25',
          value: 25,
        },
        {
          text: '50',
          value: 50,
        },
        {
          text: '100',
          value: 100,
        },
        {
          text: 'All',
          value: -1,
        },
      ],
      filters: {
        createdAt: [],
      },
      headers: [

        {
          text: 'Trade',
          align: 'left',
          value: 'id',
        },
        {
          text: 'Offer type',
          align: 'left',
          value: 'offer_type',
        },
        {
          text: 'Offer id',
          align: 'left',
          value: 'offer.id',
        },
        {
          text: 'Project',
          value: 'sell_offer.asset.title',
        },
        {
          text: 'Security wallet',
          value: 'sell_offer.security_wallet',
        },
        {
          text: 'State',
          align: 'left',
          value: 'sell_offer.state',
        },
        {
          text: 'Total',
          align: 'left',
          value: 'total',
        },
        {
          text: 'Created at',
          value: 'created_at',
        },
        {
          text: 'Updated at',
          value: 'updated_at',
        },
      ],
    };
  },
  computed: {
    filteredItems() {
      return this.trades.filter(d => Object.keys(this.filters).every((f) => {
        if (this.filters[f]) {
          return (
            this.filters[f].length < 1 ||
            String(this.filters[f]).includes(d[f])
          );
        }

        return true;
      }));
    },
  },
  watch: {
    async trades() {
      this.getDefaultFilters();
      await this.$nextTick();
      await this.changePage();
    },
    search(val) {
      setQuery(
        {
          search: val,
        },
        this.$route,
        this.$router,
      );
    },
  },
  methods: {
    ...mapActions(['deleteCancellableTrades']),
    formatDate(date) {
      return this.$moment(date).format('MMMM Do YYYY, h:mm:ss a');
    },
    formatDateSmall(date) {
      return this.$moment(date).format('DD/MM/YYYY');
    },
    centsToEuros(amount) {
      amount = `${parseInt(amount, 0) / 100}`;

      return `${parseFloat(amount).toFixed(2)} €`;
    },
    toggleAll() {
      if (this.selected.length) {
        this.selected = [];
      } else {
        this.selected = this.trades.slice();
      }
    },
    changeSort(column) {
      if (this.pagination.sortBy === column) {
        this.pagination.descending = !this.pagination.descending;
      } else {
        this.pagination.sortBy = column;
        this.pagination.descending = false;
      }
    },
    updatePagination(pagination) {
      if (this.isLoadTableData) {
        setQuery(
          {
            page: pagination.page,
          },
          this.$route,
          this.$router,
        );
      }
    },
    toogleSelected(props) {
      props.selected = !props.selected;
    },
    async changePage() {
      const { page, search } = this.$route.query;
      this.search = search;
      await this.$nextTick();
      this.isLoadTableData = true;
      this.pagination.page = page ? Number(page) : 1;
    },
    getDefaultFilters() {
      if (this.$route.query) {
        Object.keys(this.$route.query).forEach((item) => {
          let value = this.$route.query[item];

          if (Object.prototype.hasOwnProperty.call(this.filters, item)) {
            if (typeof this.filters[item] === 'string') {
              this.filters[item] = value;
            } else if (String(this.$route.query[item]).includes(';')) {
              value = this.$route.query[item].split(';');
              this.filters[item] = value;
            } else {
              this.filters[item].push(value);
            }
          }
        });
      }
    },
    async cancelTrades() {
      const data = { ids: this.selected.map(v => v.id) };

      await this.deleteCancellableTrades(data);

      this.approveModalOpen = false;
      this.selected = [];
    },

    formatField(str, item) {
      if (str) {
        const camelCaseSentence = str.replace(/([-_]\w)/g, g => g[1].toUpperCase());
        const sentence = _.startCase(camelCaseSentence);

        if (item) {
          if (str === 'security_wallet' && item.offer.asset.provider === 'baaderbank') {
            return `${_.capitalize(sentence)} / Baader Bank account`;
          }
        }

        return _.capitalize(sentence);
      }

      return '';
    },

    formatValue(value, key) {
      if (key === 'total' || key === 'unit_price') {
        return this.centsToEuros(value);
      }
      if (key.includes('_at')) {
        return this.formatDate(value);
      }

      return value;
    },
  },
};
</script>

<style lang="scss" scoped>
a {
  text-decoration: none;
  color: black;
}

.toolbar {
  background-color: #1a4c7d;
  color: white;
}

.infoLabel {
  margin-left: 16px;
}

.countLabel {
  color: #fff;
}
</style>



// WEBPACK FOOTER //
// src/components/trades/CancellableTrades.vue